/* Argentinísimo — interacciones de la marca */
(function () {
  'use strict';

  /* ---------- navegación inferior (celular) ---------- */
  function abrir(que) {
    if (que === 'menu') {
      var s = document.querySelector('#Details-menu-drawer-container > summary');
      if (s) { s.click(); window.scrollTo({ top: 0 }); }
    } else if (que === 'search') {
      var q = document.querySelector('details-modal.header__search summary, .header__search summary, .header__icon--search');
      if (q) q.click();
    } else if (que === 'cart') {
      var c = document.getElementById('cart-icon-bubble');
      if (c) c.click();
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-arg-open]');
    if (!b) return;
    e.preventDefault();
    abrir(b.dataset.argOpen);
  });

  function actualizarContador() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-arg-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('arg:cart', { detail: cart }));
      })
      .catch(function () {});
  }
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, actualizarContador);
  }
  document.addEventListener('arg:refresh-cart', actualizarContador);

  var dinero = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('es-AR', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- vista previa de la personalización ---------- */
  document.addEventListener('input', function (e) {
    var w = e.target.closest('[data-personalizacao-wrapper]');
    if (!w) return;
    var n = w.querySelector('input[name="properties[Nome]"]');
    var num = w.querySelector('input[name="properties[Número]"]');
    var tn = w.querySelector('[data-arg-pv-name]');
    var tnum = w.querySelector('[data-arg-pv-num]');
    if (tn && n) tn.textContent = (n.value.trim() || 'TU NOMBRE').toUpperCase();
    if (tnum && num) tnum.textContent = num.value.trim() || '10';
  });

  /* ---------- barra de compra fija (celular, página de producto) ---------- */
  function barraCompra() {
    if (!document.body.classList.contains('arg-t-product')) return;
    var btn = document.querySelector('[id^="ProductSubmitButton-"]');
    if (!btn || !('IntersectionObserver' in window)) return;
    var titulo = (document.querySelector('.product__title h1') || {}).textContent || document.title;
    var precio = document.querySelector('.product__info-container .price-item--last, .product__info-container .price-item--regular');
    var img = document.querySelector('.product__media img');
    var bar = document.createElement('div');
    bar.className = 'arg-sticky';
    bar.innerHTML = (img ? '<img src="' + (img.currentSrc || img.src) + '" alt="">' : '') +
      '<div class="arg-sticky__info"><div class="arg-sticky__t"></div><div class="arg-sticky__p"></div></div>' +
      '<button type="button" class="arg-btn arg-btn--sol">Agregar</button>';
    bar.querySelector('.arg-sticky__t').textContent = titulo.trim();
    var p = bar.querySelector('.arg-sticky__p');
    var syncPrecio = function () { var el = document.querySelector('.product__info-container .price-item--last, .product__info-container .price-item--regular'); if (el) p.textContent = el.textContent.trim(); };
    syncPrecio();
    document.body.appendChild(bar);
    /* Mientras el cliente no tocó un talle, la barra lo lleva a elegirlo (el tema preselecciona el primero). */
    var talleTocado = false;
    var cta = bar.querySelector('button');
    var hayTalles = !!document.querySelector('variant-selects fieldset input[type=radio]');
    var pintarCta = function () { cta.textContent = (hayTalles && !talleTocado) ? 'Elegí tu talle' : 'Agregar'; };
    pintarCta();
    document.addEventListener('change', function (e) {
      var vs = e.target.closest('variant-selects');
      if (vs && vs.querySelector('fieldset') === e.target.closest('fieldset')) { talleTocado = true; pintarCta(); }
    });
    cta.addEventListener('click', function () {
      if (hayTalles && !talleTocado) {
        var fs = document.querySelector('variant-selects fieldset');
        fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        fs.classList.remove('arg-flash'); void fs.offsetWidth; fs.classList.add('arg-flash');
        return;
      }
      var b = document.querySelector('[id^="ProductSubmitButton-"]');
      if (!b) return;
      b.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { b.click(); }, 450);
    });
    /* visible solo cuando no se ve el botón principal, los talles ni el personalizador:
       así nunca tapa lo que el cliente está eligiendo */
    var enPantalla = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) enPantalla.add(en.target); else enPantalla.delete(en.target); });
      bar.classList.toggle('is-on', enPantalla.size === 0);
      syncPrecio();
    }, { rootMargin: '0px 0px -40px 0px' });
    io.observe(btn);
    ['variant-selects', '[data-arg-pz]'].forEach(function (sel) { var el = document.querySelector(sel); if (el) io.observe(el); });
  }

  /* ---------- carrito: "Completá tu combo" ---------- */
  function cargarRecos(box) {
    if (!box || box.dataset.loaded) return;
    box.dataset.loaded = '1';
    var id = box.dataset.productId;
    if (!id) return;
    var excluir = (box.dataset.exclude || '').split(',');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'recommendations/products.json?product_id=' + id + '&limit=10&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var lista = box.querySelector('[data-arg-recos-list]');
        var prods = (data.products || []).filter(function (p) { return p.available && excluir.indexOf(String(p.id)) === -1; }).slice(0, 6);
        if (!prods.length || !lista) return;
        lista.innerHTML = prods.map(function (p) {
          var vs = p.variants.filter(function (v) { return v.available && !(v.options || []).some(function (o) { return /^personalizar$/i.test(String(o).trim()); }); });
          if (!vs.length) return '';
          var opts = vs.map(function (v) { return '<option value="' + v.id + '">' + v.title.replace(/\s*\/\s*(sin|no) personalizar/i, '').replace(/"/g, '') + '</option>'; }).join('');
          var src = (p.featured_image || '').replace(/^(https?:)?\/\/cdn\.shopify\.com\/s\/files\/\d+\/\d+\/\d+\/\d+\//, '/cdn/shop/');
          var img = src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
          return '<div class="argc-reco"><a class="argc-reco__top" href="' + p.url + '"><img src="' + img + '" alt="" loading="lazy" width="64" height="64">' +
            '<span><span class="argc-reco__t">' + p.title.replace(/</g, '&lt;') + '</span><span class="argc-reco__p">' + dinero(p.price) + '</span></span></a>' +
            '<div class="argc-reco__row">' + (vs.length > 1 ? '<select aria-label="Talle">' + opts + '</select>' : '<select hidden>' + opts + '</select>') +
            '<button type="button" data-arg-add>+ Sumar</button></div></div>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-arg-add]');
    if (!b) return;
    e.preventDefault();
    var sel = b.parentElement.querySelector('select');
    if (!sel) return;
    b.disabled = true; b.textContent = '…';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var drawer = document.querySelector('cart-drawer');
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(sel.value), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || 'error');
        try {
          drawer.renderContents({ id: Number(sel.value), sections: res.sections });
        } catch (err) {
          var doc = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
          var nuevo = doc.querySelector('#CartDrawer');
          if (nuevo) document.querySelector('#CartDrawer').innerHTML = nuevo.innerHTML;
        }
        if (drawer) drawer.classList.toggle('is-empty', false);
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'arg-recos' });
        actualizarContador();
      })
      .catch(function () { b.disabled = false; b.textContent = '+ Sumar'; });
  });

  function vigilarCarrito() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var revisar = function () { cargarRecos(drawer.querySelector('[data-arg-recos]')); };
    new MutationObserver(revisar).observe(drawer, { childList: true, subtree: true });
    revisar();
  }

  /* ---------- fechas de entrega (días hábiles) ---------- */
  var MESES = ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sep.', 'oct.', 'nov.', 'dic.'];
  function sumarHabiles(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n--; } return d; }
  function fechas() {
    document.querySelectorAll('[data-arg-eta]:not([data-done])').forEach(function (el) {
      el.setAttribute('data-done', '');
      var a = sumarHabiles(new Date(), +el.dataset.min || 9), b = sumarHabiles(new Date(), +el.dataset.max || 20);
      el.textContent = a.getMonth() === b.getMonth()
        ? 'entre el ' + a.getDate() + ' y el ' + b.getDate() + ' de ' + MESES[b.getMonth()]
        : 'entre el ' + a.getDate() + ' de ' + MESES[a.getMonth()] + ' y el ' + b.getDate() + ' de ' + MESES[b.getMonth()];
    });
  }

  /* ---------- talle elegido siempre visible ---------- */
  function talleElegido() {
    document.querySelectorAll('variant-selects fieldset, .product-form__input--pill').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var marcado = fs.querySelector('input[type=radio]:checked');
      if (!legend || !marcado) return;
      var span = legend.querySelector('.arg-sel');
      if (!span) { span = document.createElement('span'); span.className = 'arg-sel'; legend.appendChild(span); }
      span.textContent = marcado.value;
    });
  }
  document.addEventListener('change', function (e) { if (e.target.closest('variant-selects')) setTimeout(talleElegido, 60); });
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    window.subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(talleElegido, 80); });
  }
  /* respaldo: el tema reemplaza el selector al cambiar de variante */
  document.querySelectorAll('product-info, .product__info-container').forEach(function (root) {
    new MutationObserver(function () { if (root.querySelector('variant-selects legend') && !root.querySelector('variant-selects legend .arg-sel')) talleElegido(); })
      .observe(root, { childList: true, subtree: true });
  });

  /* ---------- "Cuantas más llevás, menos pagás": objetivo elegido + carrito real ---------- */
  var METAS = { 3: 2, 5: 3, 7: 4, 10: 5 };
  var enCarrito = 0;
  function metaElegida() { try { var m = +localStorage.getItem('argMeta'); return METAS[m] ? m : 3; } catch (e) { return 3; } }
  function guardarMeta(m) { try { localStorage.setItem('argMeta', String(m)); } catch (e) {} }
  function pl(n, a, b) { return n === 1 ? a : b; }
  function pintarMetas() {
    var g = metaElegida(), paga = METAS[g], gratis = g - paga, n = enCarrito;
    document.querySelectorAll('[data-arg-meta]').forEach(function (box) {
      box.querySelectorAll('[data-meta]').forEach(function (b) {
        var on = +b.dataset.meta === g; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var noAplica = g === 10 && !box.dataset.e10;
      var txt;
      if (noAplica) txt = 'Este modelo no entra en <strong>llevá 10, pagá 5</strong>. Sí suma para llevá 3, 5 o 7.';
      else if (n === 0) txt = 'Objetivo: <strong>llevá ' + g + ', pagá ' + paga + '</strong> · sumá ' + g + ' camisetas y ahorrás ' + gratis + ' ' + pl(gratis, 'camiseta', 'camisetas') + '.';
      else if (n < g) txt = 'Objetivo: <strong>llevá ' + g + ', pagá ' + paga + '</strong> · tenés ' + n + ', ' + pl(g - n, 'falta', 'faltan') + ' ' + (g - n) + '. Ahorrás ' + gratis + ' ' + pl(gratis, 'camiseta', 'camisetas') + '.';
      else txt = '¡Objetivo cumplido! Tenés ' + n + ' en el carrito: <strong>llevás ' + g + ' y pagás ' + paga + '</strong>' + (g === 10 ? ' (camisetas seleccionadas)' : '') + '.';
      var msg = box.querySelector('[data-meta-msg]'); if (msg) msg.innerHTML = txt;
    });
    /* colección: pastilla flotante con el progreso */
    if (!document.querySelector('.arg-meta--col')) return;
    var pill = document.querySelector('.arg-metapill');
    if (!pill) {
      pill = document.createElement('button'); pill.type = 'button'; pill.className = 'arg-metapill';
      pill.addEventListener('click', function () { var d = document.querySelector('cart-drawer'); if (d && d.open) d.open(); else window.location.href = (window.routes && routes.cart_url) || '/cart'; });
      document.body.appendChild(pill);
    }
    pill.hidden = n === 0;
    pill.innerHTML = n >= g
      ? '<b>' + n + '</b><span>¡Listo! Llevás ' + g + ', pagás ' + paga + '</span><em>Ver carrito →</em>'
      : '<b>' + n + '</b><span>Sumá ' + (g - n) + ' más y llevás ' + g + ', pagás ' + paga + '</span><em>Ver →</em>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-arg-meta] [data-meta]');
    if (!b) return;
    guardarMeta(+b.dataset.meta); pintarMetas();
  });
  document.addEventListener('arg:cart', function (e) { enCarrito = (e.detail && e.detail.item_count) || 0; pintarMetas(); });

  /* ---------- "Volver a la colección": la última que el cliente miró ---------- */
  (function () {
    var t = document.querySelector('.arg-ctop__title');
    if (document.body.classList.contains('arg-t-collection') && t) {
      try { sessionStorage.setItem('argColeccion', JSON.stringify({ u: location.pathname + location.search, t: t.textContent.trim() })); } catch (e) {}
    }
    var v = document.querySelector('[data-arg-volver]');
    if (!v) return;
    try {
      var c = JSON.parse(sessionStorage.getItem('argColeccion') || 'null');
      if (c && c.u && c.t) { v.href = c.u; v.querySelector('[data-arg-volver-t]').textContent = c.t; }
    } catch (e) {}
  })();

  /* pie: columnas abiertas en escritorio, plegadas en celular */
  function pie() {
    if (window.matchMedia('(min-width: 750px)').matches) {
      document.querySelectorAll('[data-arg-footer-col]').forEach(function (d) { d.open = true; });
    }
  }

  function iniciar() {
    barraCompra(); vigilarCarrito(); pie(); fechas(); talleElegido();
    if (document.querySelector('[data-arg-meta]')) { pintarMetas(); actualizarContador(); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else { iniciar(); }


  /* ---------- cards: galería de fotos (deslizar, puntos, flechas, hover) ---------- */
  function fotoActual(t) { return Math.round(t.scrollLeft / Math.max(1, t.clientWidth)); }
  function irAFoto(t, i, suave) {
    var n = t.children.length; if (n < 2) return;
    i = (i + n) % n;
    t.scrollTo({ left: i * t.clientWidth, behavior: suave ? 'smooth' : 'auto' });
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('arg-card__track') || t._argRaf) return;
    cargarFotos(t.parentNode);
    t._argRaf = requestAnimationFrame(function () {
      t._argRaf = 0;
      var i = fotoActual(t), d = t.parentNode.querySelectorAll('.arg-card__dots i');
      for (var k = 0; k < d.length; k++) d[k].classList.toggle('is-on', k === i);
    });
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-card-nav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var t = b.parentNode.querySelector('.arg-card__track');
    if (t) irAFoto(t, fotoActual(t) + (+b.dataset.cardNav), true);
  });
  /* las fotos extra se cargan recién al primer toque / mouse: la grilla no pesa más */
  function cargarFotos(m) {
    if (!m || m._argFotos) return;
    m._argFotos = true;
    var imgs = m.querySelectorAll('img[data-src]');
    for (var k = 0; k < imgs.length; k++) {
      imgs[k].srcset = imgs[k].getAttribute('data-srcset'); imgs[k].src = imgs[k].getAttribute('data-src');
      imgs[k].removeAttribute('data-src'); imgs[k].removeAttribute('data-srcset');
    }
  }
  ['touchstart', 'pointerover', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { cargarFotos(e.target.closest && e.target.closest('.arg-card__media--gal')); }, { passive: true, capture: true });
  });
  /* computadora: al pasar el mouse se ve la segunda foto (en carruseles y grillas) */
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var m = e.target.closest && e.target.closest('.arg-card__media--gal');
    if (!m || m.contains(e.relatedTarget)) return;
    var t = m.querySelector('.arg-card__track');
    if (t && fotoActual(t) === 0) { t._argHover = true; irAFoto(t, 1, true); }
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var m = e.target.closest && e.target.closest('.arg-card__media--gal');
    if (!m || m.contains(e.relatedTarget)) return;
    var t = m.querySelector('.arg-card__track');
    if (t && t._argHover) { t._argHover = false; irAFoto(t, 0, true); }
  });

  /* ocultar la barra al bajar, mostrar al subir */
  var nav = document.querySelector('.arg-mnav');
  if (nav) {
    var y0 = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (Math.abs(y - y0) < 8) return;
      nav.classList.toggle('is-hidden', y > y0 && y > 300);
      y0 = y;
    }, { passive: true });
  }
})();
